<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          
		  <el-form-item label="门店" v-if="!userInfo.shop_id">
		    <el-select
		      v-model="search.shop_id"
		      clearable
		      remote
		      filterable
		      :remote-method="remoteMethod"
		      placeholder="请输入店铺名称"
		      class="w140"
		    >
		      <el-option
		        v-for="item in options.shop_id"
		        :key="item.shopId"
		        :label="item.shopName"
		        :value="item.shopId"
		      />
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="市场" v-if="!userInfo.shop_id">
		    <el-select
		      v-model="search.market_id"
		      clearable
          filterable          
		      placeholder="请选择市场"
		      class="w140"
		    >
		      <el-option
		        v-for="item in options.market_idList"
		        :key="item.id"
		        :label="item.name"
		        :value="item.id"
		      />
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="日期">
		    <el-date-picker
		      v-model="search.deal_time"
		      type="daterange"
		      range-separator="至"
		      start-placeholder="开始日期"
		      end-placeholder="结束日期"
		      class="w240"
		      value-format="yyyy-MM-dd"
		    ></el-date-picker>
		  </el-form-item>
		  
		  <el-form-item label="客户名称">
            <el-input
              v-model="search.customer_name"
              maxlength="30"
              class="w120"
              clearable
              placeholder="请输入客户名称"
            />
          </el-form-item>
          
		  <el-form-item label="护理师">
		    <el-input v-model="search.name" maxlength="30" class="w140" placeholder="请输入护理师名称" />
		  </el-form-item>
          
		  <el-form-item label="状态">
		    <el-select v-model="search.status" clearable class="w140" placeholder="请选择统状态">
		      <el-option
		        v-for="item in options.status"
		        :label="item.name"
		        :value="item.val"
		        :key="item.val"
		      />
		    </el-select>
		  </el-form-item>
		  
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
        <el-button
          type="primary"
          class="mb10"
          size="mini"
          @click="getList('export')"
        >导出全部</el-button>
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            v-loading="loading"
          >
            <ElTableColumn v-if="!userInfo.shop_id" type="selection" width="50" />
            <ElTableColumn label="预约时间" prop="yy_time" />
            <ElTableColumn label="市场" prop="market_name" />
            <ElTableColumn label="门店" prop="shop_name" />
            <ElTableColumn label="客户名称" prop="customer_name" />
            <ElTableColumn label="预约护理师" prop="staff_name" />
            <ElTableColumn label="当前状态" prop="jindu" />
            <ElTableColumn label="核销时间" prop="is_use_time" />
            <ElTableColumn label="生成时间" prop="create_time" />
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pagination from "@/components/Pagination";
import { getShopList ,readAdminMarketList1} from "@/api/shop";
import { transferShopList, transferShopExport, booksList, booksExport } from "@/api/client";

class Search {
  customer_name = ""; // 客户名称
  market_id = ""; // 市场名称
  type = "PC";
  shop_id = ""; // 店铺
  name = ""; // 员工名称
  deal_time = []; // 预约时间区间
  status = "";
}
class Options {
	shop_id = [];
  market_idList = [];
	constructor() {
		this.status = [
		  { val: 1, name: "已核销" },
		  { val: 2, name: "待核销" },
		  { val: 3, name: "已过期" },
		  { val: 4, name: "已取消" }
		];
	}
}
class Page {
  total = 0;
  page = 1;
  limit = 10;
}
export default {
  name: "StaffList",
  components: {
    pagination
  },
  data() {
    return {
      search: new Search(), // 检索条件
      options: new Options(), // 选项
      page: new Page(), // 分页
      list: [], // 数据展示
      idList: [], // 选中的ID列表
      loading: false // 加载状态
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.getList();
    this.getMarketList();
  },
  methods: {
    // 搜索门店
    remoteMethod(e) {
      getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
        this.options.shop_id = res.list;
      });
    },
    getMarketList() {
       readAdminMarketList1({action: "market"}).then(res => {
          this.options.market_idList = res;
        });
    },
    // 导出全部
    goExport() {
    },
    
    // 获取列表
    getList(option) {
      if (option === "search") this.page = new Page();
     

      
      this.loading = true;
      let params = {
        ...this.search,
        ...this.page,
        export :  option === "export" ? 1 : 0
      };
      
      // 处理日期参数
      if (this.search.deal_time && this.search.deal_time.length === 2) {
        params.deal_start_time = this.search.deal_time[0];
        params.deal_end_time = this.search.deal_time[1];
        delete params.deal_time;
      }
      booksList(params).then(res => {
        if(option === "export"){
              window.open(res.url);
        }else{

          this.list = res.list;
          this.page.total = res.dataCount;
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    
  }
};
</script>

<style lang="scss" scoped>
.mainColor {
  color: #2dc0a3;
}
.content {
  height: calc(100% - 56px);
  overflow-y: auto;
}
.bgW {
  background: #fff;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 20px;
}

.el-form-item {
  margin: 5px 40px 3px 0;
}
.accountCon {
  background: #fff;
  padding: 0px 10px 80px;
  .btnBox {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
  }
}
.w240 {
  width: 240px;
}
</style>